import Vue from "../../../node_modules/vue/dist/vue.min";

import bootstrap from "../../../node_modules/bootstrap/dist/js/bootstrap.bundle";
import MultiSelect from "vue-multiselect";

import AOS from "../../../node_modules/aos/dist/aos.js";
import "../../../node_modules/prismjs/prism";
import "../../../node_modules/prismjs/components/prism-markup-templating";
import "../../../node_modules/prismjs/components/prism-php";
import "../../../node_modules/prismjs/components/prism-java";
import "../../../node_modules/prismjs/components/prism-csharp";
import "../../../node_modules/prismjs/components/prism-javascript";
import "../../../node_modules/prismjs/components/prism-ruby";
import "../../../node_modules/prismjs/components/prism-go";
import "../../../node_modules/prismjs/components/prism-python";
import "../../../node_modules/prismjs/components/prism-swift";
import "../../../node_modules/prismjs/components/prism-kotlin";

import "../../../node_modules/@fortawesome/fontawesome-free/js/all.js";

window.Vue = Vue;
window.bootstrap = bootstrap;
window.VueMultiselect = MultiSelect;
window.AOS = AOS;

